<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/activities/discounts/form' }">
        <a-button type="primary" icon="plus">发布打折活动</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.tags"
              placeholder="请输入Tag标题"
              enter-button
              @search="getLists()"
            />
          </div>
        </standard-form-row>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />

      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="{ y: scroll.y }"
      >
        <template slot="start_time" slot-scope="value">{{
          moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')
        }}</template>
        <template slot="expire_time" slot-scope="value">{{
          moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')
        }}</template>
        <template slot="state" slot-scope="text, record">
          <a-switch
            checked-children="生效"
            un-checked-children="无效"
            :checked="record.state === 1"
            @change="value => handleChangeState(record.tag)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <router-link v-action:update :to="'/activities/discounts/form/' + record.tag">
            <a-button type="link"><a-icon type="edit" /> 编辑</a-button>
          </router-link>
          <a-popconfirm title="确定要删除吗？" @confirm="() => handleOnDelete(record.tag)" v-action:delete>
            <a href="javascript:;"><a-icon type="delete" /> 删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table } from '@/mixins' // 引入
import { TagSelect, StandardFormRow, TableToolBarList } from '@/components'
const TagSelectOption = TagSelect.Option

const apiList = {
    getList: '/activities/discounts',
    delete: '/activities/discounts/',
    changeState: '/activities/discounts/'
}
const columns = [
    {
        title: '标题',
        dataIndex: 'title',
        sorter: true
    },
    {
        title: 'Tag',
        dataIndex: 'tag',
        align: 'center'
    },
    {
        title: '开始时间',
        dataIndex: 'start_time',
        scopedSlots: { customRender: 'start_time' },
        align: 'center'
    },
    {
        title: '结束时间',
        dataIndex: 'expire_time',
        scopedSlots: { customRender: 'expire_time' },
        align: 'center'
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: 'state' },
        align: 'center'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 160,
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'DiscountList',
    mixins: [list, table], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取列表
    },
    methods: {

    }
}
</script>
